import { render } from "./ShareIcon.vue?vue&type=template&id=78ca6fac"
import script from "./ShareIcon.vue?vue&type=script&lang=js"
export * from "./ShareIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__